import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Hook to handle payment return detection and redirect
 * This helps provide better UX when users return from payment gateways
 */
export const usePaymentReturn = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const handlePaymentReturn = () => {
      // Check for pending order in session storage
      const pendingOrder = sessionStorage.getItem('pendingOrder')
      
      if (pendingOrder) {
        try {
          const { orderNumber, timestamp } = JSON.parse(pendingOrder)
          
          // Check if return is recent (within 30 minutes)
          if (Date.now() - timestamp < 30 * 60 * 1000) {
            // Clear the pending order
            sessionStorage.removeItem('pendingOrder')
            
            // Navigate to success page
            if (orderNumber) {
              navigate(`/checkout-success/${orderNumber}`, { replace: true })
            } else {
              navigate('/', { replace: true })
            }
          } else {
            // Clear expired pending order
            sessionStorage.removeItem('pendingOrder')
          }
        } catch (error) {
          // Clear invalid pending order data
          sessionStorage.removeItem('pendingOrder')
        }
      }
    }

    // Check for payment return on mount
    handlePaymentReturn()
  }, [navigate])
}

/**
 * Utility function to store pending order data before redirect
 */
export const storePendingOrder = (orderNumber: string) => {
  sessionStorage.setItem('pendingOrder', JSON.stringify({
    orderNumber,
    timestamp: Date.now()
  }))
}

/**
 * Utility function to clear pending order data
 */
export const clearPendingOrder = () => {
  sessionStorage.removeItem('pendingOrder')
}
